module.exports = __webpack_public_path__ + "static/media/optimize-data-centralization-graphics.9af0732f.png";